import Footer from "../components/Footer";
import NavBar from "../components/Navbar/NavBar";
import ServiceDetail from "../components/ServiceDetail";
import Crypto from "../images/crypto.png";

export default function Blockchain() {
  return (
    <>
        <NavBar />
        <ServiceDetail
          titleKey="services.s3_title"
          descriptionKey="services.s3_more"
          image={Crypto}
          highlights={[
              "services.s3_point_1",
              "services.s3_point_2",
              "services.s3_point_3",
          ]}
          />
        <Footer />
    </>
  );
}
